/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'

import { BtnAddForm, BtnBack, BtnDraft, BtnHome, BtnReject, BtnSend } from 'components/Common/Button';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
//
import { AlertMsgTh, AlertTitleTh, AlertTitle, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';

import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import CpnPopUpMap from '../ComponentVOC/CpnPopUpMap';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import moment from 'moment';
import Accordion from 'components/Common/Accordion/Accordion';
import { Grid, Typography, useMediaQuery } from '@mui/material'
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import CpnSuggestGuest from './CpnSuggestGuest';
import CpnSuggestCustomer from './CpnSuggestCustomer';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { BiEdit } from "react-icons/bi";
import VerticalStepper from 'components/Stepper/VerticalStepper';
import secureLocalStorage from 'react-secure-storage';

const OptionTypeSuggest = [
    { value: "1", label: "Customer" },
    { value: "0", label: "Guest" },
]

const PageSuggest = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout1300 = useMediaQuery('(min-width:1300px)');
    //useState
    const [sVOCFormID, setsVOCFormID] = useState(location?.state ? location.state["sVOCFormID"] : null)
    const [IsRead, setIsRead] = useState(location?.state ? location.state["isRead"] : false)
    const [nStatusID, setnStatusID] = useState(0)
    const [sMode, setsMode] = useState("edit")  //edit, view, Super
    const [sTypeSuggestion, setsTypeSuggestion] = useState("1")
    const [isInputTelRequireCust, setisInputTelRequireCust] = useState(false)
    const [IsAddTelExtentionCust, setIsAddTelExtentionCust] = useState(false)
    const [IsAddTelExtentionGuest, setIsAddTelExtentionGuest] = useState(false)
    const [lstBA, setlstBA] = useState(location?.state ? location.state["lstBa"] : [])
    const [sBA, setsBA] = useState(location?.state ? location.state["sBA"] : null)
    const [OptionBA, setOptionBA] = useState([] as any)
    const [ALLlistOptionBA, setALLlistOptionBA] = useState([] as any)
    const [Option, setOption] = useState({
        lstBA: [],
        lstCompany: [],
        lstCompanyAddress: [],
        lstVOCType: [],
        lstVOCService: [],
        lstTel: [],
        lstContactType: [],
        lstTypeResolve: [],
        lstTypeCompliant: [],
        lstReqInprogress: [],
        lstTypeResponPerson: [],
        lstResponPerson: [],
        lstStatus: [],
    })
    const [IsAddAddress, setIsAddAddress] = useState(false)
    const [IsOpenMap, setIsOpenMap] = useState(false)
    const [isSetMap, setIsSetMap] = useState(false)
    const [oLocationCurrent, setoLocationCurrent] = useState({
        lat: null,
        lng: null,
    })
    const [sLocation, setsLocation] = useState({
        Latitude: null,
        Longitude: null,
        Address: null,
    })
    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": [],
        "lstRoleUser": [],
    })

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    //#region  Form

    const schema = yup.object().shape({
        sTypeSuggestion: yupFormSchemas.string("SUGGESTION", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })

    const schemaCustomer = yup.object().shape({
        //1
        sJobCode: yupFormSchemas.string("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        oCustomer: yupFormSchemas.object("ลูกค้า", { required: true }),
        oBA: yupFormSchemas.object("กลุ่มตลาด", { required: true }),
        oCompany: yupFormSchemas.object("บริษัท", { required: true }),
        oAddress: yupFormSchemas.object("ที่อยู่/สถานที่เกิดเหตุ", { required: true }),
        sAddress: yupFormSchemas.string("ที่อยู่/สถานที่เกิดเหตุ", { required: IsAddAddress }),
        oTel: yupFormSchemas.object("หมายเลขโทรศัพท์", { required: true }),
        // sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: isInputTelRequire }),
        sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: isInputTelRequireCust, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: "กรุณากรอกข้อมูลเฉพาะตัวเลข" }),
        sInputTelExtension: yupFormSchemas.string("เบอร์ต่อ", { required: IsAddTelExtentionCust, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: "กรุณากรอกข้อมูลเฉพาะตัวเลข" }),
        oNoticeChannel: yupFormSchemas.object("ช่องทางที่รับแจ้ง", { required: true }),
        sDetailSuggestion: yupFormSchemas.string("รายละเอียดข้อแนะนำ", { required: true }),
        sDateIssue: yupFormSchemas.string("วันที่แจ้ง", { required: true }),
        sTimeIssue: yupFormSchemas.string("เวลาที่แจ้ง", { required: true }),
        sNote: yupFormSchemas.string("โน้ต", { required: false }),
    });
    const formCustomer = useForm({
        resolver: yupResolver(schemaCustomer),
        mode: 'all',
        shouldFocusError: true,
    })

    const schemaSuggestion = yup.object().shape({
        //1
        sJobCode: yupFormSchemas.string("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        sFname: yupFormSchemas.string("ชื่อ", { required: true }),
        sLname: yupFormSchemas.string("นามสกุล", { required: true }),
        oBA: yupFormSchemas.object("กลุ่มตลาด", { required: true }),
        sCompany: yupFormSchemas.string("บริษัท", { required: true }),
        sAddress: yupFormSchemas.string("ที่อยู่/สถานที่เกิดเหตุ", { required: false }),
        // sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: false }),
        // sInputTelExtension: yupFormSchemas.string("เบอร์ต่อ", { required: false }),
        sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: false, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: "กรุณากรอกข้อมูลเฉพาะตัวเลข" }),
        sInputTelExtension: yupFormSchemas.string("เบอร์ต่อ", { required: false, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: "กรุณากรอกข้อมูลเฉพาะตัวเลข" }),
        sEmail: yupFormSchemas.email("อีเมล", { required: false }),
        oNoticeChannel: yupFormSchemas.object("ช่องทางที่รับแจ้ง", { required: true }),
        sDetailSuggestion: yupFormSchemas.string("รายละเอียดข้อแนะนำ", { required: true }),
        sDateIssue: yupFormSchemas.datetime("วันที่แจ้ง", { required: true }),
        sTimeIssue: yupFormSchemas.string("เวลาที่แจ้ง", { required: true }),
        sNote: yupFormSchemas.string("โน้ต", { required: false }),
    });
    const formSuggestion = useForm({
        resolver: yupResolver(schemaSuggestion),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        GetUserData();
        let TypeForm = form.getValues("sTypeSuggestion") || "1";
        form.setValue("sTypeSuggestion", TypeForm)

        const urlParams = new URLSearchParams(location.search);
        const sParamVOCFormID = urlParams.get("strMail");
        let sParamVOCID = "";
        if ((location?.state && location?.state["sVOCFormID"])) {
            sParamVOCID = location?.state["sVOCFormID"];
            setsVOCFormID(location?.state["sVOCFormID"])
        }
        else if (sParamVOCFormID) {
            sParamVOCID = sParamVOCFormID;
            setsVOCFormID(sParamVOCFormID)
            setIsRead(true)
        }

        if (sParamVOCID != "") {
            secureLocalStorage.removeItem("LinkTo");
            secureLocalStorage.removeItem("sUserType");
            //Get Data for update
            GetDataVOCID(sParamVOCID);
            setsMode("view")
        }
        else {
            GetNewInitailFormVOC()
        }

        AxiosGet(`BAService/GetBA`, { "IsSuggestion": true }, (res) => {
            ResultAPI(res, null, () => {
                setALLlistOptionBA(res.result.data || [])
            })
        });

    }, [location?.state])


    useEffect(() => {
        if (sLocation.Address != null) {
            if (form.getValues("sTypeSuggestion") === "1") {
                formCustomer.setValue("sAddress", sLocation.Address)
                formCustomer.clearErrors("sAddress")
            }
            else {
                formSuggestion.setValue("sAddress", sLocation.Address)
                formSuggestion.clearErrors("sAddress")
            }

        }
    }, [sLocation.Address])

    const GetUserData = async () => {
        AxiosGet("User/GetUserData", { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                let lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                //เช็คแค่นี้ไม่พอ ไม่ในหน่วยงานที่หมอบหมายด้วย
                // setIsRoleDM(res.result.sPISRole == "DM" ? true : false)
                setDataUser({
                    "nUserID": res.result.nUserID || "",
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                    "lstRoleUser": res.result.lstRole || []
                });
            })
        })
    };

    const GetOptiontEditFormVOCAll = async (Result) => {
        BlockUI();

        let oOptionVOC = {
            lstBA: [],
            lstCompany: [],
            lstCompanyAddress: [],
            lstVOCType: [],
            lstVOCService: [],
            lstTel: [],
            lstContactType: [],
            lstTypeResolve: [],
            lstTypeCompliant: [],
            lstReqInprogress: [],
            lstTypeResponPerson: [],
            lstResponPerson: [],
            lstStatus: [],
        };

        if (Result?.objCustomer && Result?.objCustomer?.value) {
            AxiosGet(`User/GetUserTelById`, { "nUserID": Result?.objCustomer?.value, "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstTel: res.result?.data || [] }

                })
            });

            // nBAID //follow login
            AxiosPost(`Company/SearchCompany`, { "nBAID": DataUser.lstUserBA, "sLanguage": "th", "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstCompany: res.result?.data || [] }

                })
            });

        }

        if (Result.objCompany && Result?.objCompany?.value) {
            AxiosGet(`Company/GetCompanyAddress`, { "nUserID": parseInt(Result?.objCustomer?.value), "nCompanyID": Result?.objCompany?.value, "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstCompanyAddress: res.result?.data || [] }

                })
            });

            if (Result?.objAddr?.value) {
                AxiosGet(`BAService/GetBAByAddress`, { "nAddrID": parseInt(Result?.objAddr?.value) }, (res) => {
                    ResultAPI(res, null, () => {
                        oOptionVOC = { ...oOptionVOC, lstBA: res.result?.data || [] }
                    })
                });
            }
        }


        await AxiosGet(`BAService/GetContactType`, {}, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstContactType: res.result?.data || [] }
            })
        });

        await onSetOption(oOptionVOC);

    }

    const GetNewInitailFormVOC = async () => {
        BlockUI();

        let oOptionVOC = {
            lstBA: [],
            lstCompany: [],
            lstCompanyAddress: [],
            lstVOCType: [],
            lstVOCService: [],
            lstTel: [],
            lstContactType: [],
            lstTypeResolve: [],
            lstTypeCompliant: [],
            lstReqInprogress: [],
            lstTypeResponPerson: [],
            lstResponPerson: [],
            lstStatus: [],
        };


        await AxiosGet(`BAService/GetBA`, { "IsSuggestion": true }, (res) => {
            ResultAPI(res, null, () => {
                setOptionBA(res.result.data || [])
                oOptionVOC = { ...oOptionVOC, lstBA: res.result.data || [] }
            })
        });
        await AxiosGet(`BAService/GetBAType`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCType: res.result.data || [] }
            })
        });
        await AxiosGet(`BAService/GetContactType`, {}, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstContactType: res.result.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 2 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeResolve: res.result.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 3 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeCompliant: res.result.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 5 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstReqInprogress: res.result.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 6 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeResponPerson: res.result.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 7 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstResponPerson: res.result.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetStatusCreateVOC`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstStatus: res.result.data || [] }
            })
        });

        await onSetOption(oOptionVOC);
    }

    const onSetOption = async (paramOption) => {
        setOption(paramOption)
        UnBlockUI();
    }

    const onSaveFlowRead = async (sParamVOCFormID) => {
        let oParam = {
            "sVOCFormID": sParamVOCFormID,
            "sMode": "R",
        }
        if (sParamVOCFormID != "") {

            await AxiosPost(`VOC/SaveVOCFormData`, oParam, (res) => {
                ResultAPI(res, null, () => {
                })
            }, null, null)
        }
    }

    const GetDataVOCID = async (sParamVOCFormID) => {
        BlockUI();
        await onSaveFlowRead(sParamVOCFormID);
        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: sParamVOCFormID }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                let Result = res.result?.data
                if (Result != null) {
                    await GetOptiontEditFormVOCAll(Result)

                    setnStatusID(Result.nStatusID)
                    let dIssueDate = moment(Result.dIssueDate);
                    formCustomer.setValue("sDateIssue", dIssueDate)
                    formSuggestion.setValue("sDateIssue", dIssueDate)

                    let sTypeSuggestion = Result.sCustomerType == "E" && Result.nCustomerID != null ? "1" : "0";
                    form.setValue("sTypeSuggestion", sTypeSuggestion)
                    setsTypeSuggestion(sTypeSuggestion)

                    if (sTypeSuggestion === "1") {
                        //1
                        formCustomer.setValue("sJobCode", Result.sJobCode)
                        formCustomer.setValue("sVOCFormCode", Result.sVOCFormCode)
                        formCustomer.setValue("oCustomer", Result.objCustomer)
                        formCustomer.setValue("oCompany", Result.objCompany?.label == null ? null : Result.objCompany)
                        formCustomer.setValue("oAddress", Result.objAddr?.label == null ? null : Result.objAddr)
                        formCustomer.setValue("oTel", Result.objTel?.label == null ? null : Result.objTel)
                        formCustomer.setValue("oNoticeChannel", Result.objContactType?.label == null ? null : Result.objContactType)
                        formCustomer.setValue("sDetailSuggestion", Result.sDetail)
                        formCustomer.setValue("sShowBA", Result.sBA)
                        // formCustomer.setValue("oBA", sBA)
                        //For display only
                        if (Result.objOwnerBA?.label == null && Result.lstBAID != null && Result.lstBAID.length > 0) {
                            let arr = { value: "1", label: Result.sBA }
                            formCustomer.setValue("oBA", arr)
                        }
                        else {
                            formCustomer.setValue("oBA", Result.objOwnerBA)
                        }

                        let dIssueDate = moment(Result.dIssueDate)
                        // let dTimeIssue = dIssueDate.format("HH:mm");
                        formCustomer.setValue("sTimeIssue", dIssueDate)

                        formCustomer.setValue("sNote", Result.sNoteSuggestion)
                    }
                    else {
                        if (Result.objOwnerBA?.label == null && Result.lstBAID != null && Result.lstBAID.length > 0) {
                            let arr = { value: "1", label: Result.sBA }
                            formSuggestion.setValue("oBA", arr)
                        }
                        else {
                            formSuggestion.setValue("oBA", Result.objOwnerBA)
                        }

                        // formSuggestion.setValue("oBA", Result.objOwnerBA?.label == null ? null : Result.objOwnerBA)
                        formSuggestion.setValue("sJobCode", Result.sJobCode)
                        formSuggestion.setValue("sVOCFormCode", Result.sVOCFormCode)
                        formSuggestion.setValue("sFname", Result.sExternal_FName)
                        formSuggestion.setValue("sLname", Result.sExternal_LName)
                        formSuggestion.setValue("sCompany", Result.sExternal_CompanyName)
                        formSuggestion.setValue("sAddress", Result.sExternal_Address)
                        formSuggestion.setValue("sInputTel", Result.sExternal_Tel)
                        formSuggestion.setValue("sInputTelExtension", Result.sExternal_Tel_Extension)
                        setIsAddTelExtentionGuest(Result.sExternal_Tel_Extension !== null && Result.sExternal_Tel_Extension !== "")
                        formSuggestion.setValue("sEmail", Result.sExternal_Email)
                        formSuggestion.setValue("oNoticeChannel", Result.objContactType?.value === "" ? null : Result.objContactType)
                        formSuggestion.setValue("sDetailSuggestion", Result.sDetail)

                        let dIssueDate = moment(Result.dIssueDate);
                        // let dTimeIssue = dIssueDate.format("HH:mm");
                        // formSuggestion.setValue("sTimeIssue", dTimeIssue)
                        formSuggestion.setValue("sTimeIssue", dIssueDate)

                        formSuggestion.setValue("sNote", Result.sNoteSuggestion)
                    }
                }

            })
        })
    }
    //Submit Form
    const onSubmitSuggestion = (statusMode = "C") => {
        let sMessage = statusMode == "D" ? "คุณต้องการที่จะบันทึกร่างใช่หรือไม่ ?" : "คุณต้องการที่จะบันทึกและปิดใบงานใช่หรือไม่ ?"

        if (statusMode == "D") {
            formCustomer.clearErrors();
            formSuggestion.clearErrors();
        }

        let oParam = {};
        if (form.getValues("sTypeSuggestion") === "1") {
            let MessageValidate = "<div style='text-align:left;'>กรุณาระบุข้อมูลดังนี้</div>";
            let isPassDraft = true;
            if (statusMode == "D") {

                if (!formCustomer.getValues("oCustomer")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- ลูกค้า</p>`
                    isPassDraft = false;
                }
                if (!formCustomer.getValues("oBA")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- กลุ่มตลาด</p>`
                    isPassDraft = false;
                }
                if (!formCustomer.getValues("oCompany")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- บริษัท</p>`
                    isPassDraft = false;
                }
                if (!formCustomer.getValues("oAddress")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- ที่อยู่/สถานที่เกิดเหตุ</p>`
                    isPassDraft = false;
                }
                if (!formCustomer.getValues("sDateIssue")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- วันที่แจ้ง</p>`
                    isPassDraft = false;
                }
                if (!formCustomer.getValues("sTimeIssue")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- เวลาที่แจ้ง</p>`
                    isPassDraft = false;
                }
            }

            if (isPassDraft) {
                oParam = {
                    "sVOCFormID": sVOCFormID,
                    "sMode": statusMode,
                    "nJobTypeID": 3,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
                    "cCustomerType": "E",
                    "nVOCFormTypeID": 3,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
                    "nCompanyID": formCustomer.getValues("oCompany") ? parseInt(formCustomer.getValues("oCompany").value) : null,
                    "nCustomerID": formCustomer.getValues("oCustomer") ? parseInt(formCustomer.getValues("oCustomer").value) : null,
                    "sDetail": formCustomer.getValues("sDetailSuggestion") ?? null,
                    "nTelID": formCustomer.getValues("oTel") ? parseInt(formCustomer.getValues("oTel").value) : null,
                    "nSelectAddrType": isSetMap === true ? 1 : 2,
                    "nAddrID": formCustomer.getValues("oAddress") ? parseInt(formCustomer.getValues("oAddress").value) : null,
                    "nContactTypeID": formCustomer.getValues("oNoticeChannel") ? parseInt(formCustomer.getValues("oNoticeChannel").value) : null,
                    "dIssueDate": formCustomer.getValues("sDateIssue") && formCustomer.getValues("sTimeIssue") ? new Date(moment(formCustomer.getValues("sDateIssue")).format("YYYY-MM-DD") + " " + moment(formCustomer.getValues("sTimeIssue")).format("HH:mm")) : null,
                    "sIssueDate": formCustomer.getValues("sDateIssue") && formCustomer.getValues("sTimeIssue") ? moment(formCustomer.getValues("sDateIssue")).format("DD/MM/YYYY") + " " + moment(formCustomer.getValues("sTimeIssue")).format("HH:mm") : null,
                    "IsAllowEmailAlert": formCustomer.getValues("sNoticeEmail") && formCustomer.getValues("sNoticeEmail") === "1" ? true : false,
                    "IsCreateVOCByBA": true,
                    "nOwnerBAID": formCustomer.getValues("oBA") ? parseInt(formCustomer.getValues("oBA").value) : null,
                    "objFormNote": [
                        {
                            "sVOCFormID": sVOCFormID,
                            "sNote": formCustomer.getValues("sNote") ?? null,
                        }
                    ],
                    "cMoreCustomerTel": {
                        "nCustomerID": formCustomer.getValues("oCustomer") ? parseInt(formCustomer.getValues("oCustomer").value) : null,     //nCustomerID
                        "sTel": formCustomer.getValues("sInputTel") ?? null,
                        "sExtension": formCustomer.getValues("sInputTelExtension") ?? null
                    },
                    "cMoreAddress": {
                        "nCompanyID": formCustomer.getValues("oCompany") ? parseInt(formCustomer.getValues("oCompany").value) : null,
                        "sAddress": formCustomer.getValues("sAddress") ?? null,
                        "sLatitude": sLocation.Latitude ? sLocation.Latitude + "" : null,
                        "sLongitude": sLocation.Longitude ? sLocation.Longitude + "" : null,
                    },
                }
                SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
                    BlockUI();
                    AxiosPost(`VOC/SaveVOCFormData`, oParam, (res) => {
                        ResultAPI(res, null, () => {
                            if (res.statusCode === 200) {
                                setIsOpenSnackbar(true);
                                let sHTML = <><p>บันทึกข้อมูลสำเร็จ</p></>
                                setsMessageSnackbar(sHTML)
                                setsSeveritySnackbar("success")
                                setTimeout(() => {
                                    UnBlockUI();
                                    onGotoBack();
                                }, 2000)
                            }
                            else {
                                setIsOpenSnackbar(true);
                                setsMessageSnackbar(res.Message)
                                setsSeveritySnackbar("warning")
                                UnBlockUI();

                            }
                        })
                    }, null, null)
                })
            }
            else {
                SwAlert.Warning("แจ้งเตือน", MessageValidate, () => { });
            }
        }
        else {
            let MessageValidate = "<div style='text-align:left;'>กรุณาระบุข้อมูลดังนี้</div>";
            let isPassDraft = true;
            if (statusMode == "D") {

                if (!formSuggestion.getValues("sFname")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- ชื่อ</p>`
                    isPassDraft = false;
                }
                if (!formSuggestion.getValues("sLname")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- นามสกุล</p>`
                    isPassDraft = false;
                }
                if (!formSuggestion.getValues("oBA")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- กลุ่มตลาด</p>`
                    isPassDraft = false;
                }
                if (!formSuggestion.getValues("sDateIssue")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- วันที่แจ้ง</p>`
                    isPassDraft = false;
                }
                if (!formSuggestion.getValues("sTimeIssue")) {
                    MessageValidate += `<p style='text-align:left;margin: 0;'>- เวลาที่แจ้ง</p>`
                    isPassDraft = false;
                }
            }
            if (isPassDraft) {

                oParam = {
                    "sVOCFormID": sVOCFormID,
                    "sMode": statusMode,
                    "nJobTypeID": 3,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
                    "cCustomerType": "P",
                    "nVOCFormTypeID": 3,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
                    "sDetail": formSuggestion.getValues("sDetailSuggestion") ?? null,
                    "nContactTypeID": formSuggestion.getValues("oNoticeChannel") ? parseInt(formSuggestion.getValues("oNoticeChannel").value) : null,
                    "dIssueDate": formSuggestion.getValues("sDateIssue") && formSuggestion.getValues("sTimeIssue") ? new Date(moment(formSuggestion.getValues("sDateIssue")).format("YYYY-MM-DD") + " " + moment(formSuggestion.getValues("sTimeIssue")).format("HH:mm")) : null,
                    "sIssueDate": formSuggestion.getValues("sDateIssue") && formSuggestion.getValues("sTimeIssue") ? moment(formSuggestion.getValues("sDateIssue")).format("DD/MM/YYYY") + " " + moment(formSuggestion.getValues("sTimeIssue")).format("HH:mm") : null,
                    "sExternal_FName": formSuggestion.getValues("sFname") ?? null,
                    "sExternal_LName": formSuggestion.getValues("sLname") ?? null,
                    "sExternal_CompanyName": formSuggestion.getValues("sCompany") ?? null,
                    "sExternal_Tel": formSuggestion.getValues("sInputTel") ?? null,
                    "sExternal_Tel_Extension": formSuggestion.getValues("sInputTelExtension") ?? null,
                    "sExternal_Email": formSuggestion.getValues("sEmail") ?? null,
                    "sExternal_Address": formSuggestion.getValues("sAddress") ?? null,
                    "sExternal_Latitude": sLocation.Latitude ? sLocation.Latitude + "" : null,
                    "sExternal_Longitude": sLocation.Longitude ? sLocation.Longitude + "" : null,
                    "IsCreateVOCByBA": true,
                    "nOwnerBAID": formSuggestion.getValues("oBA") ? parseInt(formSuggestion.getValues("oBA").value) : null,
                    "objFormNote": [
                        {
                            "sVOCFormID": sVOCFormID,
                            "sNote": formSuggestion.getValues("sNote") ?? null,
                        }
                    ],
                }

                SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
                    BlockUI();
                    AxiosPost(`VOC/SaveVOCFormData`, oParam, (res) => {
                        ResultAPI(res, null, () => {
                            if (res.statusCode === 200) {
                                setIsOpenSnackbar(true);
                                let sHTML = <><p>บันทึกข้อมูลสำเร็จ</p></>
                                setsMessageSnackbar(sHTML)
                                setsSeveritySnackbar("success")
                                setTimeout(() => {
                                    UnBlockUI();
                                    onGotoBack();
                                }, 2000)
                            }
                            else {
                                setIsOpenSnackbar(true);
                                setsMessageSnackbar(res.Message)
                                setsSeveritySnackbar("warning")
                                UnBlockUI();

                            }
                        })
                    }, null, null)
                })
            }
            else {
                SwAlert.Warning("แจ้งเตือน", MessageValidate, () => { });
            }
        }
    }

    const onHandleField = async (eventValue, sField) => {
        if (sField === "Customer") {
            //กรอง หมายเลขโทรศัพท์ 

            formCustomer.clearErrors("oCompany")
            formCustomer.clearErrors("oAddress")
            formCustomer.clearErrors("oTel")
            formCustomer.setValue("oCompany", null)
            formCustomer.setValue("oAddress", null)
            formCustomer.setValue("oTel", null)
            if (eventValue && eventValue.value) {
                let lstTEL = [] as any;
                let lstCompany = [] as any;
                let lstCompanyAddress = [] as any;
                let lstBA = [] as any;

                await AxiosGet(`User/GetUserTelById`, { "nUserID": eventValue.value, "IsAdd": true }, (res) => {
                    ResultAPI(res, null, () => {
                        lstTEL = res.result?.data || [];
                        // setOption({ ...Option, lstTel: lstTEL })
                    })
                });


                // nBAID //follow login
                await AxiosPost(`Company/SearchCompany`, { "nBAID": DataUser.lstUserBA, "nUserID": [eventValue.value], "sLanguage": "th", "IsAdd": true }, (res) => {
                    ResultAPI(res, null, () => {
                        lstCompany = res.result?.data || [];
                        setOption({ ...Option, lstTel: lstTEL, lstCompany: lstCompany })
                    })
                });

                let ResultDefault = null;

                await AxiosGet(`Customer/GetDefaultDataCustomerNoPIS`, { "nUserID": eventValue.value }, (res) => {
                    UnBlockUI();
                    ResultAPI(res, null, async () => {
                        ResultDefault = res;
                        formCustomer.setValue("oCompany", res.oDefaultCompany ?? null)
                        formCustomer.setValue("oAddress", res.oDefaultAddress ?? null)
                        formCustomer.setValue("oTel", res.oDefaultTel ?? null)
                    })
                });

                if (ResultDefault.oDefaultCompany != null) {
                    await AxiosGet(`Company/GetCompanyAddress`, { "nCompanyID": parseInt(ResultDefault?.oDefaultCompany?.value), "nUserID": eventValue.value, "IsAdd": true }, (res) => {
                        ResultAPI(res, null, () => {
                            lstCompanyAddress = res.result?.data || []
                            // setOption({ ...Option , lstTel: lstTEL, lstCompany: lstCompany , lstCompanyAddress: lstCompanyAddress })
                        })
                    });
                }
                if (ResultDefault?.oDefaultAddress) {
                    await AxiosGet(`BAService/GetBAByAddress`, { "nAddrID": parseInt(ResultDefault?.oDefaultAddress?.value) }, (res) => {
                        ResultAPI(res, null, () => {
                            lstBA = res.result?.data || [];
                            if (lstBA.length == 1) {
                                formCustomer.setValue("oBA", lstBA[0] || {})
                                formCustomer.clearErrors("oBA")
                            }
                        })
                    });
                }

                setOption({ ...Option, lstTel: lstTEL, lstCompany: lstCompany, lstCompanyAddress: lstCompanyAddress, lstBA: lstBA })

            }
        }
        else if (sField === "BA") {
            //กรอง บริษัท
            if (eventValue && eventValue.value) {
                let nBAID = [parseInt(eventValue.value) ?? 0]  //follow login
                // AxiosPost(`Company/SearchCompany`, { "nBAID": 1, "sLanguage": "th" }, (res) => {
                //     ResultAPI(res, null, () => {
                //         setOption({ ...Option, lstCompany: res.result.data || [] })
                //     })
                // });
                if (form.getValues("oVOCType")) {
                    let nVOCTypeID = form.getValues("oVOCType") ? parseInt(form.getValues("oVOCType").value) : 0
                    let nBAID = parseInt(eventValue.value) ?? 0
                    // AxiosGet(`BAService/GetBAService`, { "nVOCTypeID": nVOCTypeID }, (res) => {
                    AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID }, (res) => {
                        ResultAPI(res, null, () => {
                            setOption({ ...Option, lstVOCService: res.result.data || [] })
                        })
                    });
                }
            }
        }
        else if (sField === "Company") {
            //กรอง สถานที่
            let oCustomer = form.getValues("oCustomer")
            if (eventValue && eventValue.value) {

                let lstCompanyAddress = [] as any;
                let lstBA = [] as any;

                AxiosGet(`Company/GetCompanyAddress`, { "nUserID": parseInt(oCustomer?.value), "nCompanyID": parseInt(eventValue.value) ?? 0, "IsAdd": true }, (res) => {
                    ResultAPI(res, null, () => {
                        lstCompanyAddress = res.result?.data || []
                        setOption({ ...Option, lstCompanyAddress: lstCompanyAddress })
                    })
                });
                //Default BA
                if (form.getValues("oAddress")) {
                    AxiosGet(`BAService/GetBAByAddress`, { "nAddrID": parseInt(form.getValues("oAddress")?.value) }, (res) => {
                        ResultAPI(res, null, () => {
                            lstBA = res.result?.data || [];
                            setOption({ ...Option, lstCompanyAddress: lstCompanyAddress, lstBA: lstBA })
                            if (lstBA.length == 1) {
                                form.setValue("oBA", lstBA[0] || {})
                                form.clearErrors("oBA")
                            }
                        })
                    });
                }

            }
        }
        else if (sField === "TypeVOC") {
            //กรอง ปัญหาที่พบ
            if (eventValue && eventValue.value) {
                let nBAID = formCustomer.getValues("oBA") ? parseInt(formCustomer.getValues("oBA").value) : 0
                let nVOCTypeID = parseInt(eventValue.value) ?? 0
                // AxiosGet(`BAService/GetBAService`, { "nVOCTypeID": nVOCTypeID }, (res) => {
                AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID }, (res) => {
                    ResultAPI(res, null, () => {
                        setOption({ ...Option, lstVOCService: res.result.data || [] })
                    })
                });

            }
        }
    }


    const handleChangeSuggestion = (sType) => {

        setIsAddAddress(false)
        setIsSetMap(false)
        setoLocationCurrent({ lat: null, lng: null })
        setsLocation({
            Latitude: null,
            Longitude: null,
            Address: null,
        })

        setsTypeSuggestion(sType)
        if (sType === "1") {
            Object.keys(formSuggestion.getValues()).forEach((key => {
                formSuggestion.setValue(key, null);
                formSuggestion.clearErrors(key);
            }))
        } else {
            Object.keys(formCustomer.getValues()).forEach((key => {
                formCustomer.setValue(key, null);
                formCustomer.clearErrors(key);
            }))
        }
    }

    const onGotoBack = () => {
        // let sUrl = "/Backend/MyCreateVOCList";
        navigate(-1);
    }

    const onCancelVOC = () => {
        let param = {
            "sVOCFormID": sVOCFormID,
        }
        SwAlert.Confirm(AlertTitleTh.Confirm, "คุณต้องการที่จะยกเลิกใบงานใช่หรือไม่ ?", () => {
            BlockUI();
            AxiosGet(`VOC/CancelVOC`, param, (res) => {
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        setIsOpenSnackbar(true);
                        let sHTML = "บันทึกข้อมูลสำเร็จ"
                        setsMessageSnackbar(sHTML)
                        setsSeveritySnackbar("success")
                        setTimeout(() => {
                            UnBlockUI();
                            onGotoBack();
                        }, 2000)
                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();
                    }
                })
            }, null, null)
        })
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<BiEdit style={{ fontSize: '1.5em' }} />}
                labal_Head="สร้างใบงาน"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ marginTop: '0' }}>
                <Grid item xs={12} md={nStatusID != 0 && sVOCFormID != null && Layout1300 ? 10 : 12}>

                    <Accordion header={"ข้อมูลข้อแนะนำ"}>
                        <Grid container spacing={2} direction="row" justifyContent="end" alignItems="start" style={{ marginTop: '-76px' }}>
                            <Grid item >
                                <FormProvider {...form}>
                                    <RadioFormItem
                                        name="sTypeSuggestion"
                                        label=""
                                        required={false}
                                        options={OptionTypeSuggest}
                                        value={form.getValues("sTypeSuggestion")}
                                        disable={sMode === "view"}
                                        row={true}
                                        IsNewLine={false}
                                        onChange={(e) => {
                                            handleChangeSuggestion(e)
                                        }}
                                    />
                                </FormProvider>
                            </Grid>
                            <Grid item xs={12} style={{ display: form.getValues("sTypeSuggestion") == "0" ? "" : "none" }}>
                                <FormProvider {...formSuggestion}>
                                    <CpnSuggestGuest
                                        form={formSuggestion}
                                        OptionBA={OptionBA}
                                        sMode={sMode}
                                        Option={Option}
                                        onHandleField={onHandleField}
                                        setIsOpenMap={setIsOpenMap}     //for Add address
                                        nStatusID={nStatusID}
                                        sVOCFormID={sVOCFormID}
                                        ALLlistOptionBA={ALLlistOptionBA}
                                        IsAddTelExtentionGuest={IsAddTelExtentionGuest}
                                        setIsAddTelExtentionGuest={setIsAddTelExtentionGuest}
                                    />
                                </FormProvider>
                            </Grid>

                            <Grid item xs={12} style={{ display: form.getValues("sTypeSuggestion") == "1" ? "" : "none" }}>
                                <FormProvider {...formCustomer}>
                                    <CpnSuggestCustomer
                                        form={formCustomer}
                                        Option={Option}
                                        sMode={sMode}
                                        onHandleField={onHandleField}
                                        IsAddAddress={IsAddAddress}
                                        setIsAddAddress={setIsAddAddress}
                                        setIsOpenMap={setIsOpenMap}     //for Add address
                                        setsLocation={setsLocation}
                                        setoLocationCurrent={setoLocationCurrent}
                                        setIsSetMap={setIsSetMap}
                                        setisInputTelRequireCust={setisInputTelRequireCust}
                                        nStatusID={nStatusID}
                                        sVOCFormID={sVOCFormID}
                                        lstBA={lstBA}
                                        sBA={sBA}
                                        IsAddTelExtentionCust={IsAddTelExtentionCust}
                                        setIsAddTelExtentionCust={setIsAddTelExtentionCust}
                                    />
                                </FormProvider>

                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                    <Grid item>
                                        {
                                            IsRead == false || [0].includes(nStatusID) ?
                                                form.getValues("sTypeSuggestion") === "1"
                                                    ?
                                                    <BtnSend txt={"บันทึกและปิดใบงาน"} onClick={formCustomer.handleSubmit(() => { onSubmitSuggestion("C") })} />
                                                    :
                                                    <BtnSend txt={"บันทึกและปิดใบงาน"} onClick={formSuggestion.handleSubmit(() => { onSubmitSuggestion("C") })} />
                                                : null
                                        }
                                    </Grid>
                                    <Grid item>
                                        {
                                            IsRead == false || [0].includes(nStatusID) ?
                                                form.getValues("sTypeSuggestion") === "1"
                                                    ?
                                                    <BtnDraft txt={"บันทึกร่าง"} onClick={() => { onSubmitSuggestion("D") }} />
                                                    :
                                                    <BtnDraft txt={"บันทึกร่าง"} onClick={() => { onSubmitSuggestion("D") }} />
                                                : null
                                        }
                                    </Grid>
                                    {
                                        ((IsRead == false || [0].includes(nStatusID)) && sVOCFormID != null && sVOCFormID != "") ?
                                            <Grid item>
                                                <BtnReject txt={"ยกเลิกใบงาน"} onClick={() => { onCancelVOC() }} />
                                            </Grid>
                                            : null
                                    }
                                    <Grid item>
                                        <BtnBack onClick={() => { onGotoBack() }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <CpnPopUpMap
                            setIsOpen={setIsOpenMap}
                            IsOpen={IsOpenMap}
                            sMaxWidth={"md"}
                            setsLocation={setsLocation}
                            setoLocationCurrent={setoLocationCurrent}
                            oLocationCurrent={oLocationCurrent}
                            onConfirm={() => {
                                setIsSetMap(true)
                            }}
                        />
                        <SnackbarCustom
                            IsOpen={IsOpenSnackbar}
                            Severity={sSeveritySnackbar}
                            OnClose={() => { setIsOpenSnackbar(false) }}
                            Message={sMessageSnackbar}
                        />
                    </Accordion>
                </Grid>
                <Grid item xs={12} md={2} style={{ display: nStatusID != 0 && sVOCFormID != null && Layout1300 ? '' : 'none' }}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                            <VerticalStepper sVOCFormID={sVOCFormID} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )
}

export default PageSuggest